var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5309 2.36407C20.7059 2.47225 20.8125 2.66336 20.8125 2.86914V20.6816C20.8125 21.0096 20.5467 21.2754 20.2188 21.2754H16.6562C16.3283 21.2754 16.0625 21.0096 16.0625 20.6816V18.9004H14.875V20.6816C14.875 21.0096 14.6092 21.2754 14.2812 21.2754H3.59375C3.26583 21.2754 3 21.0096 3 20.6816V14.1504C3 13.8948 3.16354 13.6679 3.40599 13.5871L10.125 11.3474V7.61914C10.125 7.39425 10.2521 7.18865 10.4532 7.08808L19.9532 2.33808C20.1373 2.24605 20.3559 2.25588 20.5309 2.36407ZM10.125 12.5992L4.1875 14.5783V20.0879H10.125V12.5992ZM11.3125 20.0879H13.6875V18.3066C13.6875 17.9787 13.9533 17.7129 14.2812 17.7129H16.6562C16.9842 17.7129 17.25 17.9787 17.25 18.3066V20.0879H19.625V3.82985L11.3125 7.9861V20.0879Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 15.3379H6.5625V16.5254H5.375V15.3379Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 15.3379H8.9375V16.5254H7.75V15.3379Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 17.7129H6.5625V18.9004H5.375V17.7129Z",
    fill: "#FCFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 17.7129H8.9375V18.9004H7.75V17.7129Z",
    fill: "#FCFCFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.9629H13.6875V14.1504H12.5V12.9629Z",
    fill: "#FCFCFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 12.9629H16.0625V14.1504H14.875V12.9629Z",
    fill: "#FCFCFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.3379H13.6875V16.5254H12.5V15.3379Z",
    fill: "#FCFCFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 15.3379H16.0625V16.5254H14.875V15.3379Z",
    fill: "#FCFCFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.9629H18.4375V14.1504H17.25V12.9629Z",
    fill: "#FCFCFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.3379H18.4375V16.5254H17.25V15.3379Z",
    fill: "#FCFCFD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5879H13.6875V11.7754H12.5V10.5879Z",
    fill: "#FCFCFD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 10.5879H16.0625V11.7754H14.875V10.5879Z",
    fill: "#FCFCFD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.5879H18.4375V11.7754H17.25V10.5879Z",
    fill: "#FCFCFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.21289H13.6875V9.40039H12.5V8.21289Z",
    fill: "#FCFCFD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 8.21289H16.0625V9.40039H14.875V8.21289Z",
    fill: "#FCFCFD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.21289H18.4375V9.40039H17.25V8.21289Z",
    fill: "#FCFCFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.83789H18.4375V7.02539H17.25V5.83789Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesWhite);
export default __webpack_public_path__ + "static/media/companies_white.a4aa683a5e5e45923dfe68d75cecff08.svg";
export { ForwardRef as ReactComponent };